import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spin } from 'antd';
import _debounce from 'lodash/debounce';

import { DEFAULT_PLUGIN_THUMBNAIL } from '../../config/media';
import { requestPlugins } from '../../common/fetch';
import Home from './Home';

class PluginList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isOpen: false,
			mobileToggle: false,
			isLoading: false,
			plugins: [],
			selectedPlugin: {},
			pluginCards: [],
			isMobile: false
		};
	}

	componentDidMount() {
		this.getAllPlugins();
		window.addEventListener('resize', this.handleResize);
		this.handleResize();
	}
	componentWillUnmount() {
		window.removeEventListener('resize', () => { })
	}
	handleResize = (e) => {
		const { innerWidth } = window;
		const { isMobile } = this.state;

		if (innerWidth <= 960 && !isMobile) {
			this.setState({ isMobile: true });
		} else if (innerWidth > 960 && isMobile) {
			this.setState({ isMobile: false })
		}
	};
	getAllPlugins = (params = {}) => {
		this.setState({ isLoading: true });
		requestPlugins(params)
			.then((res) => {
				if (res.data) {
					const plugins = res.data.data;
					let pluginCards = this.state.pluginCards;
					if (!params.search) {
						pluginCards = res.data.data.filter((val, key) => key <= 2)
					}
					this.setState({ plugins, isLoading: false, pluginCards });
				}
			})
			.catch(err => {
				this.setState({ isLoading: false });
			})
	};

	searchPlugin = _debounce(this.getAllPlugins, 800);

	handleOpenAdd = (plugin) => {
		const { history } = this.props;
		if (plugin.premium) {
			history.push("/kyc")
		} else {
			this.setState({
				isOpen: true,
				selectedPlugin: plugin
			});
		}
	};

	closeModal = () => {
		this.setState({ isOpen: false });
	};

	handleSearch = (e) => {
		this.searchPlugin({ search: e.target.value });
	};

	renderList = () => {
		if (this.state.isLoading) {
			return (
				<div className="loading-container">
					<Spin />
				</div>
			);
		}
		return this.state.plugins.map((item, index) => {
			return (
				<div
					key={index}
					className="flex-space-between plugin-list-item"
				>
					<div className="flex-center">
						<div>
							<img
								src={
									item.icon
										? item.icon
										: DEFAULT_PLUGIN_THUMBNAIL
								}
								alt={`plugin-${index}`}
								className="plugin-list-icon"
							/>
						</div>
						<div>
							<div className="plugin-list-title">{item.name}</div>
							<div className="plugin-list-author">{`By ${item.author}`}</div>
							<div className="plugin-list-bio">{item.bio}</div>
						</div>
					</div>
				</div>
			)
		});
	};

	render() {
		// const { isOpen, selectedPlugin, pluginCards, isMobile } = this.state;
		// const responsive = {
		// 	0: { items: 1 },
		// 	568: { items: 2 },
		// 	960: { items: 3 },
		// };
		return (
			<Home />
		);
	}
}

const mapStateToProps = (state) => ({
	exchange: state.exchange && state.exchange.length
		? state.exchange[0]
		: {},
	constant: state.constant,
});

export default connect(mapStateToProps)(PluginList);
